'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.magazine.scBeacon', []);

_module.directive('scBeaconV1', scBeaconV1);

exports.default = _module;


function scBeaconV1() {
    return {
        restrict: 'A',
        scope: true,
        controller: ['$q', '$log', '$window', function controller($q, $log, $window) {
            var vm = this;

            var isSCBeaconAvailable;

            var checkIfSCBeaconAvailable = function checkIfSCBeaconAvailable() {
                if (!isSCBeaconAvailable) {
                    isSCBeaconAvailable = $q.defer();

                    if (typeof $window.SCBeacon === 'undefined') {
                        isSCBeaconAvailable.reject('SCBeacon not available');
                    }
                    isSCBeaconAvailable.resolve('SCBeacon found!');
                }
                return isSCBeaconAvailable.promise;
            };

            vm.trackEvent = function (param) {
                checkIfSCBeaconAvailable().then(function () {
                    $window.SCBeacon.trackEvent(param);
                }).catch(function (reason) {
                    $log.warn(reason);
                });
            };

            vm.trackGoal = function (param) {
                checkIfSCBeaconAvailable().then(function () {
                    $window.SCBeacon.trackGoal(param);
                }).catch(function (reason) {
                    $log.warn(reason);
                });
            };

            vm.trackOutcome = function (param) {
                checkIfSCBeaconAvailable().then(function () {
                    $window.SCBeacon.trackOutcome(param);
                }).catch(function (reason) {
                    $log.warn(reason);
                });
            };
        }],
        controllerAs: 'scbeacon'
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/magazine/scbeacon/scbeacon.directive.js
// module id = 843
// module chunks = 0